import { render } from "./UploadIcon.vue?vue&type=template&id=d9b43c5e&bindings={}"
import script from "./UploadIcon.vue?vue&type=script&lang=ts"
export * from "./UploadIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script